<template>
  <div class="ConsumptionBox">
    <div class="Consumption"
			v-loading="loading"
			element-loading-text="加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 1)"
		>
			<template v-if="!loading">
				<div class="_ConsumpTop">
					<div class="_top">
						<div class="_left">
							<span>创建时间</span>
							<el-date-picker
								v-model="creationFrom.time"
								type="monthrange"
								align="right"
								unlink-panels
								value-format="yyyyMMdd"
								range-separator="至"
								start-placeholder="开始月份"
								end-placeholder="结束月份"
								:picker-options="pickerOptions">
							</el-date-picker>
						</div>
						<p class="_ConsumpTop_p_button" @click.stop="_search()">搜索</p>
					</div>
				</div>
				<div class="_ConsumpBot">
					<p class="_label">我的套餐</p>
					<div class="_cont">
						<el-table 
						:data="list" 
						border 
						style="width: 100%;" 
						@selection-change="handleSelectionChange">
								<el-table-column
									prop="created_at"
									align="center"
									label="创建时间">
								</el-table-column>
								<el-table-column
									prop="end_time_alias"
									align="center"
									label="结束时间">
								</el-table-column>
								<el-table-column
									prop="product_name"
									align="center"
									label="套餐名称">
								</el-table-column>
								<el-table-column
									prop="ip_count"
									align="center"
									label="IP 数量">
								</el-table-column>
								<el-table-column
									prop="ip_remaining"
									align="center"
									label="IP 剩余量">
								</el-table-column>
								<el-table-column
									prop="status"
									align="center"
									label="使用状态">
									<template slot-scope="scope">
										<span :style="{ color: scope.row.status === 0 ? '#67C23A' : '#F56C6C' }">
											{{ scope.row.status === 0 ? '未用完' : '已用完' }}
										</span>
									</template>
								</el-table-column>
						</el-table>
						<el-pagination background 
							layout="prev, pager, next, sizes, total, jumper"
							:page-sizes="[5, 10, 15, 20]"
							:page-size="pagesize"
							:total="current"
							@current-change="handleCurrentChange" 
							@size-change="handleSizeChange" 
							>
						</el-pagination>
					</div>
				</div>
			</template>
		</div>
  </div>
</template>

<script>
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
export default {
	name:'consumption',
	data(){
		return {
			msg: 8888,
			list: [],
			pagesize: 10,
			currpage: 1,
			current:0,
			creationFrom:{
				time:'',
				order:'',
				type:''
			},
			pickerOptions: {
				shortcuts: [{
					text: '本月至今',
					onClick(picker) {
						const start = new Date();
						var nowYear = start.getFullYear() //当前年
						var nowMonth = start.getMonth() //当前月（值为 0~11）
						var firstDay = new Date(nowYear,nowMonth,1)  // 本月开始时间
						start.setMonth(start.getMonth());
						picker.$emit('pick', [firstDay, new Date()]);
					}
				}, {
					text: '今年至今',
					onClick(picker) {
						const end = new Date();
						const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近六个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			loading: true
		}
	},
	created(){
		this.getListData()
	},
	methods:{
		handleCurrentChange(cpage) {
			this.currpage = cpage;
			this.getListData()
		},
		handleSizeChange(psize) {
			this.pagesize = psize;
			this.currpage = 1;
			this.getListData()
		},
		handleSelectionChange(val) {
			// console.log(val)
		},
		getListData(_sta,_end){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
				page:this.currpage,
				page_size:this.pagesize,
			}
			if(_sta) data.term_start = _sta
			if(_end) data.term_end = _end
			request({
				method: 'get', 
				url: Apis.getMyPackageList,
				params:data
			}).then(res => {
				console.log('getMyPackageList 返回:', res)
				if(res.code == 0){
					// 检查返回数据结构
					if(res.data && res.data.data) {
						this.list = res.data.data
						this.current = res.data.total || 0
					} else if(Array.isArray(res.data)) {
						// 如果直接返回数组
						this.list = res.data
						this.current = res.data.length
					} else {
						this.list = []
						this.current = 0
					}
				}else{
					this.$message.error(res.msg);
					this.list = []
					this.current = 0
				}
				this.loading = false
			}).catch((err) => {
				console.error('请求失败:', err)
				this.loading = false
				this.list = []
				this.current = 0
			});
		},
		_search(){
			if (!this.creationFrom.time) {
				this.getListData(null, null)
				return
			}
			let _sta = this.creationFrom.time[0]
			let _end = this.creationFrom.time[1]
			// 将结束时间设置为该月的最后一天
			if (_end) {
				// 先解析 yyyyMMdd 格式的日期字符串
				const year = parseInt(_end.substring(0, 4))
				const month = parseInt(_end.substring(4, 6)) - 1 // 月份从 0 开始
				// 设置为下个月 1 号，再减 1 天，得到本月最后一天
				const lastDay = new Date(year, month + 1, 0)
				_end = this.formatDate(lastDay)
			}
			this.getListData(_sta, _end)
		},
		// 格式化日期为 yyyyMMdd
		formatDate(date) {
			const year = date.getFullYear()
			const month = String(date.getMonth() + 1).padStart(2, '0')
			const day = String(date.getDate()).padStart(2, '0')
			return `${year}${month}${day}`
		}
	}
}
</script>

<style lang="less" scoped>
.ConsumptionBox{
	width: 100%;
	.Consumption{
		width: 100%;
		min-height: 880px;
		._ConsumpTop{
			width: 100%;
			height: 120px;
			background: #fff;
			position: relative;
			._top{
				width: 100%;
				display: flex;
				justify-content: space-between;
				padding: 40px 40px 50px 40px;
				._left,._right{
					// width: 50%;
					display: flex;
					// padding: 0px 40px;
					span{
						width: 100px;
						line-height: 40px;
					}
				}
				._ConsumpTop_p_button{
					position: absolute;
					right: 40px;
					bottom: 40px;
					display: inline-block;
					width: 110px;
					height: 40px;
					border-radius: 6px;
					background: #fff;
					border: 1px solid #1F8EFF;
					color: #1F8EFF;
					font-size: 16px;
					line-height: 40px;
					cursor:pointer;
				}
			}
			._bot{
				width: 50%;
				display: flex;
				padding: 20px 52px 40px 52px;
				
				
				._left,._right{
					// width: 50%;
					display: flex;
					// padding: 0px 40px;
					span{
						width: 100px;
						line-height: 40px;
						margin-right: 16px;
					}
					
				}
			}
		}
		._ConsumpBot{
			width: 100%;
			min-height: calc(100% - 240px);
			margin-top: 30px;
			background: #fff;
			padding: 37px;
			._cont{
				margin-top: 20px;
			}
			.el-pagination{
				margin-top: 20px;
			}
		}
	}
}
._label{
	// width: 140px;
	text-align: left;
	padding-left: 10px;
	position: relative;
	line-height: 30px;
	font-weight: bold;
	font-size: 20px;
	left: 10px;
}
._label::after{
	content: '';
	display: inline-block;
	width: 4px;
	height: 23px;
	background: #51B3FF;
	position: absolute;
	top: 5px;
	left: 0px;
}
</style>
<style scoped>
.ConsumptionBox >>> .el-date-editor .el-range-separator{
	padding: 0;
}
</style>
